import * as React from 'react';
import { useState } from 'react';
import { paths, colors } from './paths';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { getIndex, useFlubber } from 'lib/useFlubber';

export default function LoadingIcon() {
  const [pathIndex, setPathIndex] = useState(0);
  const progress = useMotionValue(pathIndex);
  const fill = useTransform(progress, paths.map(getIndex), colors);
  const path = useFlubber(progress, paths);

  React.useEffect(() => {
    const animation = animate(progress, pathIndex, {
      duration: 3.1,
      ease: 'easeInOut',
      onComplete: () => {
        if (pathIndex === paths.length - 1) {
          progress.set(0);
          setPathIndex(1);
        } else {
          setPathIndex(pathIndex + 1);
        }
      },
    });

    return () => animation.stop();
  }, [pathIndex]);

  return (
    <svg width="320" height="320" className="tw-ml-[20px] tw-mt-[20px]">
      <g transform="translate(10 10) scale(12 12)">
        <motion.path fill={fill} d={path} />
      </g>
    </svg>
  );
}
